<template>
    <div>

        <div v-if="!em_edicao">

            <div class="card dashcard mb-3">
            
                <div class="card-body">

                    <div class="row">
                        <div class="col col-12 col-md-6">
                            <az-input icon="fas fa-search" v-model="search" />
                        </div>
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <div class="btn-group mb-1" role="group" aria-label="Basic example">
                                <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'A'">
                                    Ativos
                                </button>
                                <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                                @click="viewMode = 'T'">
                                    Todos
                                </button>
                            </div>
                        </div>
                        <div class="col col-12 col-md-3 d-flex flex-column">
                            <button type="button" class="btn btn-outline-success" @click="incluir ()">
                                Incluir Grupo
                            </button>
                        </div>
                    </div>

                </div>

            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum grupo identificado.'" 
                icon="fas fa-search"
                :action="'Incluir Grupo'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }} 
                        </a>

                        <span class="badge badge-secondary ml-2">#{{ dado.id_estoque_grupo }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <span class="badge badge-secondary ml-1" v-if="dado.categoria">
                                {{ dado.categoria.search }}
                            </span>
                            <span class="badge badge-secondary ml-1" v-if="dado.categoria_consumo">
                                {{ dado.categoria_consumo.search }}
                            </span>

                            <a href="#" @click.prevent="acessos(dado)" class="btn btn-sm btn-outline-primary ml-2" title="Acesso">
                                <i class="fa-solid fa-user-lock"></i>
                                <span class="badge badge-primary ml-1" v-if="dado.acessos && dado.acessos.length">{{ dado.acessos.length }}</span>
                            </a>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_estoque_grupo ? '' : 'Novo' }}
                            Grupo
                            <span class="badge badge-secondary ml-3" v-if="item && item.id_estoque_grupo">
                                #{{ item.id_estoque_grupo }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_estoque_grupo" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Categoria (Aquisição)"
                                    :validate="validate"
                                    type="select"
                                    optionsMode="aql"
                                    service="categorias.index"
                                    optionsName="categorias.D"
                                    optionsData="id_categoria"
                                    optionsDisplay="search"
                                    :optionsParm="{ lancamento: true, where: { ch_natureza: 'D' } }"
                                    v-model="item.id_categoria" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Categoria (Consumo)"
                                    :validate="validate"
                                    type="select"
                                    optionsMode="aql"
                                    service="categorias.index"
                                    optionsName="categorias.D"
                                    optionsData="id_categoria"
                                    optionsDisplay="search"
                                    :optionsParm="{ lancamento: true, where: { ch_natureza: 'D' } }"
                                    v-model="item.id_categoria_consumo" />
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="checkbox-group"
                                    label="Vacina"
                                    v-model="item.fl_vacina" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="checkbox-group"
                                    label="Consumo de Paciente"
                                    v-model="item.fl_consumo_paciente" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="estoqueGrupo" :id="item.id_estoque_grupo" v-if="item && item.id_estoque_grupo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_estoque_grupo ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <edicao-acessos ref="acessos" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import EdicaoAcessos from '../../cadastros/shared/EdicaoAcessos.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            metadados: null, 
            anos: [],
            unidade: "", 
        }
    },

    props: ['cadastro'],

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton, 
        EdicaoAcessos, 
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter(item => !this.unidade || item.id_unidade_operacao == this.unidade)
                .filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        }
    },

    methods: { 
        acessos(item) { 
          this.$refs.acessos.abrir(
              'App\\azure\\estoqueGrupo', 
              item.id_estoque_grupo,
              item.search, 
            );
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_estoque_grupo: null, 
                st_estoque_grupo: "",
                fl_ativo: true,
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service: 'estoque_grupos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                },
            });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);
            $('#edicaoModal').modal('show');
        },
        atualizar () { 

            this.$util.atualizar(this, { 
                service: 'estoque_grupos',
                dados: this.item, 
                modal: 'edicaoModal',
                reload: true, 
                callback: () => { 
                    this.$util.resync(this, 'estoque_grupos.index');
                }
            });

        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'estoque_grupos', 
                dados: item, 
                callback: () => { 
                    this.$util.resync(this, 'estoque_grupos.index');
                }
            });

        },
    },

    mounted () { 
        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Grupo", path: "/suprimentos/grupo" }
        ]);

        this.load ();
    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>